// Injects a raw HTML snippet (as copy-pasted from Google Tag Manager, an ad
// platform, etc. — may contain <script> and/or <noscript> tags) into a real
// DOM node. Assigning the string to `target.innerHTML` directly wouldn't
// work for the <script> part — browsers never execute script content
// inserted that way — so each child is rebuilt as an actual element and
// re-appended, which does execute.
//
// Returns a cleanup function that removes exactly what was appended —
// callers use this from a useEffect to inject on mount and clean up on
// unmount, so navigating away and back (e.g. Login -> Register) within the
// same layout never doubles up the injected nodes.
export function injectSnippet(rawHtml, target = document.head) {
  if (!rawHtml || !rawHtml.trim()) return () => {};

  const wrapper = document.createElement("div");
  wrapper.innerHTML = rawHtml;

  const appended = [];
  [...wrapper.childNodes].forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE && node.tagName === "SCRIPT") {
      const script = document.createElement("script");
      [...node.attributes].forEach((attr) => script.setAttribute(attr.name, attr.value));
      script.textContent = node.textContent;
      target.appendChild(script);
      appended.push(script);
    } else {
      const clone = node.cloneNode(true);
      target.appendChild(clone);
      appended.push(clone);
    }
  });

  return () => appended.forEach((n) => n.parentNode?.removeChild(n));
}
